import type { WhClass } from "../types/chain";

export const CLASS_LABEL: Record<WhClass, string> = {
  C1: "C1",
  C2: "C2",
  C3: "C3",
  C4: "C4",
  C5: "C5",
  C6: "C6",
  HS: "HS",
  LS: "LS",
  Null: "NS",
  Thera: "Thera",
  C13: "C13",
  Drifter: "Drifter",
  Pochven: "P",
};
